import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlaneTop } from '@fortawesome/pro-duotone-svg-icons';
import React, { useState } from 'react';

interface CommentInputProps {
  tenderId: string;
  handleCreateComment: (tenderId: string, message: string) => void;
}

const MAX_COMMENT_LENGTH = 2000;

export const CommentInput: React.FC<CommentInputProps> = ({ tenderId, handleCreateComment }) => {
  const [comment, setComment] = useState<string>('');

  const handleSendComment = () => {
    if (comment.trim() === '') return;
    handleCreateComment(tenderId, comment.trim());
    setComment('');
  };

  const handleCommentInput = (comment: string) => {
    if (comment.trim().length <= MAX_COMMENT_LENGTH) {
      setComment(comment);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendComment();
    }
  };

  return (
    <label className="input flex h-20 max-h-52 items-start gap-2 bg-base-200 !px-2 pt-1">
      <textarea
        value={comment}
        onChange={(e) => handleCommentInput(e.target.value)}
        onKeyDown={handleKeyDown}
        className="flex grow resize-none bg-base-200 text-sm focus:outline-none"
        placeholder="Nachricht"
        rows={3}
      />
      <button onClick={handleSendComment} disabled={comment.trim() === ''}>
        <FontAwesomeIcon className="fa-fw h-4 w-4" icon={faPaperPlaneTop} />
      </button>
    </label>
  );
};
